import React from 'react'
import DisplaySectionMainContainer from '../../containers/PageProgram/DisplaySectionMainContainer'
import MoreElementsContainer from '../../containers/PageProgram/MoreElementsContainer'
import SaveStateButton from '../general/SaveStateButton'
import AddNewSectionContainer from '../../containers/forms/AddNewSectionContainer'
import WrapperPageSimple from '../WrapperPage/present/WrapperPageSimple'
import FetchProgramButton from './FetchProgramButton'
import CinemaListContainer from './cont/index'
import RequestOverlayContainer from '../overlay/container/RequestOverlayContainer'
import Translation from '../Translation/cont/Translation'
import OverlayEditSelectionContainer from '../overlay/container/OverlayEditSelectionContainer'
import requestStatus from '../../constants/requestStatus'
import canEditProgram from '../../functions/canEditProgram'


const PageProgramPage = ({pageTitleTransId, caps, closePagePath, selectionDisplayItems, programStatus, programError, onFetchProgram, uiRequestOverlayType, onUpdateProgram}) => (
    <WrapperPageSimple
        pageTitleTransId={pageTitleTransId}
        closePagePath={closePagePath}
        overlay={
            programStatus !== requestStatus.REQUEST_SUCCESS && uiRequestOverlayType ? 
                <RequestOverlayContainer
                    programStatus={programStatus} 
                    programError={programError}
                />
                :
                <OverlayEditSelectionContainer />
        }
    >
    <div className="program-page site-content">
        <FetchProgramButton 
            buttonTransId='fetch_program'
            onFetchProgram={onFetchProgram}
        />
        {!_.isEmpty(selectionDisplayItems) ? (
            <div>
                {canEditProgram(caps) && <AddNewSectionContainer 
                    type={'addNewSection'} 
                />}
                
                <CinemaListContainer />

                <div className="section-end">
                    <h2 className="gap-35 title-large"><Translation id='program_cinema_highlights'/><span className="title-placement"> <Translation id="program_huge_slider" /></span></h2>
                    <DisplaySectionMainContainer />
                </div>

                <div className="section-end">
                    <h2 className="gap-35 title-large"><Translation id="program_more_elements" /></h2>
                    <MoreElementsContainer />
                </div>

                <div className="save-program-button">
                    <SaveStateButton
                        status={programStatus}
                        transId="publish_program_button"
                        condition={true}
                        saveState={onUpdateProgram}
                    />
                </div>
            </div>
        ) : (
            <div className="program-page site-content">
                <div><Translation id="click_on_fetch" /></div>
                <div><Translation id="log_in_and_out" /> <a className="support-mail text-regular-color cursor-pointer" href="mailto:support@pmkino.com"><Translation id="support"/></a></div>
            </div>
        )} 
    </div>
    </WrapperPageSimple>
)

export default PageProgramPage